import { render, staticRenderFns } from "./SpeakersStatistics.vue?vue&type=template&id=df017fce&"
import script from "./SpeakersStatistics.vue?vue&type=script&lang=js&"
export * from "./SpeakersStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports